import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";

const ContentDistribution = ({ data }) => {
  const [barOption, setBarOption] = useState({
    chart: {
      type: "bar",
      height: 230,
      plotBorderWidth: 1,
      plotBorderColor: "#E6E6E6",
    },
    title: {
      text: "",
    },
    xAxis: {
      categories: [""],
      title: {
        text: null,
      },
      labels: {
        enabled: false,
        style: {
          color: "#97B6CF",
          fontSize: "10px",
          fontWeight: "400",
        },
      },
      gridLineWidth: 0,
      lineColor: "#E6E6E6",
    },
    yAxis: {
      title: {
        text: null,
      },
      tickAmount: 5,
      labels: {
        style: {
          color: "#97B6CF",
          fontSize: "10px",
          fontWeight: "400",
        },
        formatter: function () {
          const axis = this.axis;
          const max = axis.max;

          // If this is the last tick
          if (this.value === max) {
            return `<span style="white-space:nowrap;">Freq</span>`;
          }

          return this.value;
        },
      },
    },
    legend: {
      enabled: true,
      align: "center",
      verticalAlign: "bottom",
      layout: "horizontal",
      itemMarginTop: 5,
      itemMarginBottom: 5,
      itemDistance: 7, // gap between each legend item
      symbolPadding: 6, // gap between color dot and text (decrease this)
      symbolWidth: 10,
      symbolHeight: 10,
      symbolRadius: 5,
      itemStyle: {
        color: "#70899E",
        fontSize: "12px",
        fontWeight: "400",
      },
    },
    plotOptions: {
      series: {
        pointWidth: 28,
        borderWidth: 0,
        groupPadding: 1,
        dataLabels: {
          enabled: false,
        },
      },
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
  });

  useEffect(() => {
    if (data && data?.length) {
      const series = data.map((item) => {
        return {
          name: item?.action,
          color:
            item?.action === "Download"
              ? "#88EBE2"
              : item?.action === "Email"
                ? "#0E9B8E"
                : "#39CABC",
          data: [item?.count || 0],
        };
      });
      setBarOption((prev) => ({
        ...prev,
        series,
      }));
    }
  }, [data]);

  return (
    <div className="profile-engagement vwd-distribution">
      <div className="profile-engagement-block">
        <Row>
          <Col
            className="hcp-profile-view vwd-distribution"
            id="box-1"
            data-printable="true"
          >
            <div className="profile-title d-flex align-items-center justify-content-between">
              <p>Distribution channels</p>
            </div>
            <div className="hcp-profile-content live-events-graph">
              <p>Last 12 months engagement</p>
              {data?.length === 0 ? (
                <div className="no-data">
                  No data available
                </div>
              ) : (
                <div className="bar-graph">
                  <HighchartsReact
                    highcharts={Highcharts}
                    options={barOption}
                  />
                </div>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ContentDistribution;
